// app/javascript/controllers/header_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["wrapper", "navbar"]
  ticking = false

  connect() {
    this.toggleHeader()
    this.scrollHandler = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.scrollHandler)
  }

  disconnect() {
    window.removeEventListener('scroll', this.scrollHandler)
  }

  handleScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.toggleHeader()
        this.ticking = false
      })
      this.ticking = true
    }
  }

  toggleHeader() {
    const scrollPosition = window.scrollY
    const wrapperClasses = ['px-4', 'pt-2']
    const navbarClasses = ['max-w-4xl', 'rounded-2xl', 'scale-95']

    if (scrollPosition > 50) {
      this.wrapperTarget.classList.add(...wrapperClasses)
      this.navbarTarget.classList.add(...navbarClasses)
    } else {
      this.wrapperTarget.classList.remove(...wrapperClasses)
      this.navbarTarget.classList.remove(...navbarClasses)
    }
  }
}
